<template>
    <div :key="key">
        <div v-if="!editing" :class="reactiveClass" class="mt-1">
            <b-link title="Cliquer pour modifier" @click="edit">
                {{ displayValue }}
            </b-link>
        </div>
        <div v-if="editing" class="mt-0">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-form-input
                    v-model="form.email"
                    size="sm"
                    :state="!$v.$invalid"
                    @change="validate"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import { email } from 'vuelidate/lib/validators'
import TableFormHandler from '../../../../common/mixins/TableFormHandler'

export default {
    name: 'EmailForm',

    mixins: [TableFormHandler],

    props: {
        contact: null,
    },

    data() {
        return {
            form: {
                email: '',
            },
            editing: false,
        }
    },

    validations: {
        form: {
            email: { email },
        },
    },

    methods: {
        validate() {
            if (this.$v.$invalid) {
                this.initForm()
                this.display()
            } else {
                this.update()
            }
        },

        async update() {
            try {
                await axios.put(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`,
                    this.form
                )
                this.handleSuccess()
                this.setDisplayValue(this.form.email)
                this.display()
                this.$emit('contact-has-changed')
            } catch (error) {
                this.display()
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.email = this.contact.email
            this.setDisplayValue(this.contact.email)
            this.align = 'left'
        },

        setInitialKey() {
            this.key = `emailForm${this.contact.id}`
        },

        edit() {
            this.editing = true
        },

        display() {
            this.editing = false
        },
    },
}
</script>

<style scoped></style>
